(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["big-box-cta-banner"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function() {

    var siteHeaderWidth = $('.site-header').width();
    var winScrollTop;

    $('.big-box-cta-banner').each(function() {
      initializeBanner($(this));
    });

    $(window).resize(function() {
      siteHeaderWidth = $('.site-header').width();

      $('.big-box-cta-banner').each(function() {
        initializeBanner($(this));
      });
    });

    $(window).scroll(function(e) {
      winScrollTop = $(window).scrollTop();
      //set banner navigation fixed on scroll
      alignBannerNav(siteHeaderWidth);
    });

    /*$('.big-box-cta-banner').on('wheel', function(e) {

      var bannerOffset = $(this).offset(),
          bannerOffsetTop = bannerOffset.top,
          bannerHeight = $(this).height(),
          bannerEnd = bannerOffsetTop + bannerHeight;      

      var totalSteps = $(this).find('.big-box-cta-banner-slide').length;
      var wheelDelta = e.originalEvent.wheelDelta;

      //determine slide Index
      if (scrollStep % scrollSpeed === 0) {
        activeSlideIndex = scrollStep/scrollSpeed;
        console.log('Active slide index: ', activeSlideIndex);

        activateSlide.apply({
          currentBanner: $(this), slideIndex: activeSlideIndex 
        });
      }

      //detect scroll direction on banner
      if (wheelDelta < 0) {
        bannerScrollDirection = 'down';
        if (scrollStep/scrollSpeed <= totalSteps) {
          scrollStep++;
        }
      }
      if (wheelDelta > 0) {
        bannerScrollDirection = 'up';
        if (scrollStep/scrollSpeed >= 1) {
          scrollStep--;
        } 
      }   
      
    });*/

    
  });

  function alignBannerNav(siteHeaderWidth) {
    $('.big-box-cta-banner').each(function() {
      var winScrollTop = $(window).scrollTop();
      var bannerOffset = $(this).offset(),
          bannerOffsetTop = bannerOffset.top,
          bannerHeight = $(this).height(),
          bannerEnd = bannerOffsetTop + bannerHeight,
          bannerNav = $(this).find('.big-box-cta-banner-nav'),
          isMobile = ($('.site-header').css('height') === '100%') ? false : true,
          bannerNavWidth = 'calc(100% - ' + siteHeaderWidth + 'px)',
          bannerNavLeft = 250,
          activeSlideIndex = 1,
          winWidth = window.innerWidth;

      if (winWidth <= 1024) {
        bannerNavWidth = '100%';
        bannerNavLeft = 0;
      }

      if (winWidth >= 1024) {
        bannerHeight = bannerHeight - 100;
      }

      if (bannerOffsetTop <= winScrollTop && bannerEnd >= winScrollTop) {
        bannerNav.css({
          position: 'fixed',
          left: bannerNavLeft,
          width: bannerNavWidth 
        });
      } else {
        bannerNav.css({
          position: 'absolute',
          left: 0,
          width: '100%'
        });
      }

    });
  }
  
  function initializeBanner(banner) {
    var winHeight = window.innerHeight;
    var winWidth = window.innerWidth;
    banner.slideIndex = 1;

    if (winWidth >= 1024) {
      banner.height(winHeight);
      console.log('>1024');
    } 
    
    if (winWidth < 1024) {
      banner.height(winHeight - $('.site-header').height());
      console.log('<1024');
    }

    activateSlide.apply({
      currentBanner: banner, slideIndex: banner.slideIndex
    });

    setTimeout(function() {
      banner.removeClass('invisible');
      $('.big-box-cta-banner-box').removeClass('slide-out');
    }, 500); 
  }

  function activateSlide() {
    var slideIndex = this.slideIndex || $(this).attr('data-nav-item-id');
    var parent = this.currentBanner || $(this).closest('.big-box-cta-banner');
    parent.find('.big-box-cta-banner-slide').removeClass('active');
    parent.find('#slide-' + slideIndex).addClass('active');
    $('.big-box-cta-banner-nav-item').removeClass('active');
    if (this.slideIndex) {
      this.currentBanner.find('.big-box-cta-banner-nav-item').eq(this.slideIndex - 1).addClass('active');
    } else {
      $(this).addClass('active');
    }
  }

  $(document).on('click', '.big-box-cta-banner-nav-item', activateSlide);  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $(".pant_guide_title .guide_title").first().click();
  });

  } catch(e) { console.error(e); }
})();
})();
